import React from 'react'
import { connect } from 'react-redux'
import { LineupCreateEditForm } from 'containers'
import { lineups as lineupsModule } from 'redux/modules'
import { createSubUrl } from 'utils/urlConstructor'
import PropTypes from 'prop-types'
import { LINEUPS_DASHBOARD_ROUTE } from 'constants/routes'

const LineupEditContainer = ({ history, match, lineup, updateLineup }) => {
  const onSubmit = (values) => {
    updateLineup(match.params.lineupUuid, values).then(() =>
      history.push(createSubUrl(match, LINEUPS_DASHBOARD_ROUTE))
    )
  }

  return (
    <LineupCreateEditForm
      form="editLineup"
      initialValues={lineup}
      caption="Edit Lineup"
      onSubmit={onSubmit}
    />
  )
}

LineupEditContainer.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      lineupUuid: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  lineup: PropTypes.shape().isRequired,
  updateLineup: PropTypes.func.isRequired,
}

export default connect(
  ({ lineups }) => ({
    lineup: lineups.current,
  }),
  {
    updateLineup: lineupsModule.updateLineup,
  }
)(LineupEditContainer)
